export const error = state => state.error
export const isLoading = state => state.isLoading
export const retrieved = state => state.retrieved
export const documents = state => state.documents
export const projects = state => state.projects
export const contacts = state => state.contacts
export const addresses = state => state.addresses
